import Modal from "react-modal";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useLoader } from "../../components/loader/loader";
import { ApiUrl } from "../../config/apiConfig";
import { postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import {
  OnlyEnterNumber,
  showAPiError_mesage,
} from "../../services/validationService/validationservice";
import pluseicon from "./../../assets/img/close-circle.svg";
import Addresscomponet from "../../components/Addresscomponet";

Modal.setAppElement("#root"); // Adjust the selector to match your app's root element

interface AddTruckProps {
  isOpen: boolean;
  openModal: any;
  closeModal: () => void;
  getDataALLs?: () => void;
}

const AddCompanies = React.forwardRef((props: AddTruckProps, ref) => {
  const { isOpen, openModal, closeModal } = props;
  const { show, hide } = useLoader();
  const refd: any = useRef(null);

  useEffect(() => {
    if (openModal) {
      patchData(openModal);
    }
  }, [openModal]);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      overflow: "unset !important",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !important",
      padding: "0 !important",
      border: "none !important",
    },
  };

  const [formData, setFormData] = useState<any>({
    company_name: "",
 
    website_url:"",
  
    physical_address: {
      DropDownmanualAddress: "",
      manualAddress: "",
    },
    // country_code: "",
    contact_information: [
      {
        phone_number: "",
      },
    ],
    showOnTop:false
  });

  const [error, setError] = useState<any>({});

  const patchData = (data: any) => {
    setFormData({
      company_name: data.company_name || "",
      contact_information: data?.contact_information?.map?.((val: any) => ({
        phone_number: val.phone_number || "",
      })) || [{ phone_number: "" }],
      website_url: data.website_url || "",
      // dot_number: data.dot_number || "",
      // physical_address: data.physical_address || "",
      physical_address: {
        manualAddress: data.physical_address ? data.physical_address : "",
      },
      showOnTop:data?.showOnTop ?? false
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
      contact_information: [{ ...prev.contact_information[0] }],
    }));
    setError((prev: any) => ({ ...prev, [name]: "" }));
  };

  const handlePhoneChange = (phoneNumber: string, country: any) => {
    setFormData((prev: any) => ({
      ...prev,
      contact_information: [
        {
          ...prev.contact_information[0],
          phone_number: phoneNumber,
        },
      ],
      // country_code: country.iso2,
    }));
    setError((prev: any) => ({
      ...prev,
      phone_number: phoneNumber ? "" : prev.phone_number,
    }));
  };

  const hideErrorCustomer = () => {
    resetForm();
    setError((prevErrors: any) => {
      const newErrors = { ...prevErrors };
      delete newErrors.company_name;
      delete newErrors.phone_number;
      delete newErrors.country_code;
      delete newErrors.website_url;
       
      delete newErrors.physical_address;

      return newErrors;
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      [46, 8, 9, 27, 13, 37, 38, 39, 40].includes(e.keyCode) ||
      (e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode)) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    if (
      e.shiftKey ||
      e.keyCode < 48 ||
      (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105))
    ) {
      e.preventDefault();
    }
  };

  const handleKeyDownSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " " && (e.target as HTMLInputElement).value.length === 0) {
      e.preventDefault();
    }
  };

  const save = async () => {
    let isValid = true;
    const error: { [key: string]: string } = {};

 

    if (!formData.company_name) {
      error.company_name = "Required";
      isValid = false;
    }
    if (!formData.physical_address?.manualAddress) {
      error.physical_address = "Required";
      isValid = false;
    }

    const phoneRegex = /^\d{11}$/;

    if (!formData.contact_information[0].phone_number) {
      console.log(
        !formData.contact_information[0].phone_number,
        "addddddddddddd"
      );

      error.phone_number = "Required";
      isValid = false;
    } else if (!phoneRegex.test(formData.contact_information[0].phone_number)) {
      error.phone_number = "Invalid phone number";

      isValid = false;
    }

    const regexdot_number = /^[0-9]*$/;

    // if (!formData.dot_number) {
    //   error.dot_number = "Required";
    //   isValid = false;
    // } else if (!regexdot_number.test(formData.dot_number)) {
    //   error.dot_number = "Only numbers are allowed.";
    //   isValid = false;
    // }

    // if (!formData.mc_number) {
    //   error.mc_number = "Required";
    //   isValid = false;
    // } else if (!regexdot_number.test(formData.mc_number)) {
    //   error.mc_number = "Only numbers are allowed.";
    //   isValid = false;
    // }
    // const upperCaseValue_lincense_number =formData.mc_number?.toUpperCase() || "";
    // const regex_lincense_number = /^[A-Z0-9\s]*$/;

    // const hasLetters_lincense_number = /[A-Z]/.test( upperCaseValue_lincense_number
    // );
    // const hasNumbers_lincense_number = /\d/.test(
    //   upperCaseValue_lincense_number
    // );

    // if (!formData.mc_number) {
    //   error.mc_number = "Required";
    //   isValid = false;
    // } else if (!regex_lincense_number.test(upperCaseValue_lincense_number)) {
    //   error.mc_number = "Only alphabets and numbers are allowed.";
    //   isValid = false;
    // } else if (!hasLetters_lincense_number) {
    //   error.mc_number = "Input must contain at least one alphabets.";
    //   isValid = false;
    // } else if (!hasNumbers_lincense_number) {
    //   error.mc_number = "Input must contain at least one number.";
    //   isValid = false;
    // }
    if (!formData.website_url) {
      error.website_url = "Required";
      isValid = false;
    } else if (!/^https?:\/\/[^\s]+$/.test(formData.website_url)) {
      error.website_url = "Invalid link format";
      isValid = false;
    } 

    setError(error);
    if (isValid) {
      formData["physical_address"] =
        formData?.physical_address?.DropDownmanualAddress;
      try {
        const url = openModal?._id
          ? ApiUrl.addEditCustomer
          : ApiUrl.addEditCustomer;
        const response = await postData(
          url,
          { ...formData, _id: openModal?._id },
          { show, hide }
        );

        const messageServicesd = messageService();
        messageServicesd.toast(
          "success",
          openModal?._id
            ? messageServicesd.message.updatedSuccess
            : messageServicesd.message.addedSuccess
        );

        closeModal();
        resetForm();
        getDataALLs();
        if (response?.error?.message) {
          const MessageStore = response?.error?.message;
          showAPiError_mesage(MessageStore);
        }
      } catch (err: any) {
        if (err.response.data.message) {
          const MessageStore =err.response.data.message;
          showAPiError_mesage(MessageStore);
        }
      }
    }
  };

  const resetForm = () => {
    setFormData({
      company_name: "",
      contact_information: [{ phone_number: "" }],
 
      physical_address: "",
    });
  };

  const getDataALLs = () => {
    props.getDataALLs?.();
    refd.current?.getDataALLs();
  };

  useImperativeHandle(ref, () => ({
    hideErrorCustomer: hideErrorCustomer,
  }));

  const handlePlaceSelectedCity = (place: google.maps.places.PlaceResult) => {
    if (place && place.formatted_address) {
      setFormData((prevData: any) => ({
        ...prevData,
        physical_address: {
          DropDownmanualAddress: place?.formatted_address,
          manualAddress: place?.formatted_address,
        },
      }));
      setError((prev: any) => ({
        ...prev,
        physical_address: place.formatted_address ? "" : prev.physical_address,
      }));
    } else {
      console.error("City name not found in address components");
    }
  };

  const handleChangef = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    setFormData((prevData: any) => ({
      ...prevData,
      physical_address: (prev: any) => ({ ...prev, manualAddress: value }),
    }));
    setError((prev: any) => ({
      ...prev,
      physical_address: value ? "" : prev.physical_address,
    }));
  };

  console.log(formData, "formDataformData");
  return (
    <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    contentLabel="Add Customer Modal"
    ariaHideApp={false}
    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    overlayClassName="fixed inset-0 bg-black bg-opacity-50"
  >
    <div className="bg-white !w-[30rem] rounded-lg  max-w-2xl shadow-xl">
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-xl font-semibold">
          {openModal._id ? "Edit Customer" : "Add Customer"}
        </h2>
        <button
          type="button"
          className="text-gray-500 hover:text-gray-700"
          onClick={() => {
            resetForm();
            closeModal();
          }}
          aria-label="Close"
        >
          <img src={pluseicon} alt="Close" />
        </button>
      </div>
  
      <form className="space-y-4 p-4">
        {/* Company Name */}
        <div>
          <input
            type="text"
            placeholder="Company Name"
            className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
            value={formData.company_name}
            name="company_name"
            onChange={handleChange}
            onKeyDown={handleKeyDownSpace}
          />
          {error.company_name && <div className="text-red-500 text-sm">{error.company_name}</div>}
        </div>
  
        {/* Phone Number */}
        <div>
          <PhoneInput
            inputClass="w-full p-2 text-md border border-gray-300 rounded-md bg-white hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
            containerClass="w-full p-1  text-md border border-gray-300 rounded-md bg-white  outline-[1px] transition-all duration-500 "
            country={"us"}
            value={formData.contact_information[0]?.phone_number}
            onChange={handlePhoneChange}
            disableDropdown
            countryCodeEditable={false}
          />
          {error.phone_number && <div className="text-red-500 text-sm">{error.phone_number}</div>}
        </div>
  
        {/* Website URL */}
        <div>
          <input
            type="text"
            placeholder="Website URL"
            className="w-full p-2 text-md border border-gray-300 rounded-md  outline-[1px] transition-all duration-500 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
            value={formData.website_url}
            name="website_url"
            onChange={handleChange}
          />
          {error.website_url && <div className="text-red-500 text-sm">{error.website_url}</div>}
        </div>
  
        {/* Address */}
        <div>
          <Addresscomponet
            title="Address Modal"
            value={formData?.physical_address?.manualAddress}
            name="physical_address"
            placeholder="Address"
            onChange={handleChangef}
            handlePlaceSelectedCity={handlePlaceSelectedCity}
          />
          {error.physical_address && <div className="text-red-500 text-sm">{error.physical_address}</div>}
        </div>

        <div className="flex items-center my-7">
          
          <input checked={formData.showOnTop} value={formData.showOnTop} onChange={(e) => {
            const checked = e.target.checked;
            setFormData((prev: any) => ({
              ...prev,
              showOnTop: checked,
            }));
          }} id="checked-checkbox" type="checkbox"  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
          <label htmlFor="checked-checkbox" className="ms-2 text-sm font-medium text-gray-900 ">Show In Top Customers</label>
        </div>
  
        {/* Save Button */}
        <div className="flex justify-end items-center pt-4 border-t">
          <button
            type="button"
            className="px-6 py-2 bg-customOrange text-white rounded-md hover:bg-greenBg ease-in-out duration-300"
            onClick={save}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </Modal>
  
  );
});

export default AddCompanies;
